import React, { useState, useEffect } from "react";
import { Container, Row, Col} from "react-bootstrap";
import './PartnerForm.css'
import { useSelector, useDispatch } from 'react-redux';
import { userSelector, clearState, comejoinus } from '../../features/User/UserSlice';
import TrackApi from "../../Activity_Track/TrackApi";
import { useCookies } from "react-cookie";
function PartnerForm() {
    const dispatch = useDispatch();
    const { iscomeusjoinflag } = useSelector(
        userSelector
    );
    const [fname, setname] = useState('');
    const [nameerror, setnameerror] = useState('');
    const [email, setemail] = useState('');
    const [emailerror, setemailerror] = useState('');
    const [mobile, setmobile] = useState('');
    const [mobileerror, setmobileerror] = useState('');
    const [cookies, setCookie] = useCookies(['LeadId']);
    const handlefullname = event => {
        const value = event.target.value;
         if (/^[A-Za-z\s]*$/.test(value)) {
        setname(value);
        setnameerror("");
    }
    };
    const handleemail = event => {
        setemail(event.target.value);
        setemailerror("");
    };
    const handlemobile = event => {
        const re = /^[0-9\b]+$/;
        if (event.target.value.length < 11 && re.test(event.target.value)) {
            setmobile(event.target.value);
        }
        if (event.target.value.length == 0) {
            setmobile("");
        }
        setmobileerror("");
    };
    const clickcomeinjoin = () => {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        
        if (fname == "") {
            setnameerror("Please Enter Full Name");
            return false;
            //ret = false;
        }
        if (email == "") {
            setemailerror("Please Enter email address");
            return false;
            
        }
        if (!re.test(email)) {
            setemailerror("Please Enter valid email address");
            return false;
           
        }
        if (mobile == "") {
            setmobileerror("Please Enter mobile number");
            return false;
            
        }
        var data = {
            "name": fname, "email": email, "mobile": mobile 
        }

        dispatch(comejoinus(data));
         

    };

    useEffect(() => {

        if (iscomeusjoinflag) {
            setname("");
            setemail("");
            setmobile("");

                alert("Thank you for join us. Our Team will contact you for further process."); 
                

        }
        

    }, [iscomeusjoinflag]);
    

    const trackData=(id)=>{
      const payloadData={
        "RelatedProspectId":id,
        "ActivityNote": "Your home Note",
        "mx_Custom_1": "Partner Us",
        "mx_Custom_2": "",
        "mx_CustomObject_81":window.location.href
       }
       TrackApi(payloadData);
    }
    useEffect(()=>{
    
  if(cookies && cookies.RelatedProspectId){
    trackData(cookies.RelatedProspectId);
  }
      
    },[])
    return(
        <>
            <section className="yellow-border partner-sc">
                <Container >
                    <Row className="align-items-center">
                        <Col xl={6} ld={6} md={6} sm={12}>
                            <h2 className="pageinnerhead">Why Partner with us</h2>
                            <ul className="partner-form-data">
                                {/* <li>Get monthly interest on your ledger balance</li> */}
                                <li>Associate with Well-known and experienced brokerage firm</li>
                                <li>Brokerage sharing and Incentive on every referral</li>
                                <li>It requires no investment to collaborate and profit with us.</li>
                                <li>“0” Investment required as a Partner</li>
                                <li>Low cost with true saving</li>
                            </ul>
                        </Col>
                        <Col xl={6} ld={6} md={6} sm={12}>
                            <div className="partner-form">
                                <h6>Come Join Us</h6>
                                <div className="passtextboxnew">
                                    <label for="fullName1" className="form-label">Enter Full Name</label>
                                    <input type="text" placeholder="Enter Full Name" value={fname} onChange={handlefullname} name="name" autoComplete="on" required id="fullName1"  aria-describedby="Please enter correct name"   />
                                    <div className="clsmargin10">{nameerror != '' && <div className="errormsgnew">{nameerror}</div>}</div>  
                                </div>

                                <div className="passtextboxnew">
                                    <label for="valueEmailId" className="form-label mt-2">Enter Email Id</label>
                                    <input type="email" placeholder="Enter Email Id" value={email} onChange={handleemail} name="name" autoComplete="on" required id="valueEmailId" aria-describedby="Please enter correct email" />
                                    <div className="clsmargin10">{emailerror != '' && <div className="errormsgnew">{emailerror}</div>}</div>
                                </div>


                                <div className="passtextboxnew">
                                    <label for="mobileNum1" className="form-label mt-2">Enter Mobile Number</label>
                                    <input type="text"  placeholder="Enter Mobile Number" value={mobile} onChange={handlemobile} name="name" autoComplete="off" id="mobileNum1" required />
                                    <div className="clsmargin10">{mobileerror != '' && <div className="errormsgnew">{mobileerror}</div>}</div>  
                                </div>
                                
                                <div className="text-center">

                                    <button className="Login-Button" onClick={() => clickcomeinjoin()}>Continue</button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default PartnerForm;